'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { CheckCircle2 } from 'lucide-react';
import Link from 'next/link';
import type { BuilderDriveLink } from '@/modules/__generated__/graphql/switchboard-generated';
interface DoneStepProps {
  drive: BuilderDriveLink | null;
}
function DoneStep(t0) {
  const $ = _c(8);
  const {
    drive
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-status-success/15 text-status-success flex size-12 items-center justify-center rounded-full"><CheckCircle2 className="size-5" aria-hidden="true" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-2"><h2 className="text-2xl font-semibold tracking-tight">You're all set!</h2><p className="text-muted-foreground max-w-md text-sm">Your drive is ready. Pick where you want to go next.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button variant="outline" className="w-full min-w-0" asChild={true}><Link href="/my-account">My Account</Link></Button>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !drive;
  let t5;
  if ($[3] !== drive) {
    t5 = drive ? <a href={drive.driveLink as string} target="_blank" rel="noopener noreferrer">Explore my Workspace</a> : <span aria-disabled="true">Explore my Workspace</span>;
    $[3] = drive;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <Card><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t1}{t2}<div className="grid w-full max-w-md grid-cols-1 gap-3 sm:grid-cols-2">{t3}<Button className="w-full min-w-0" asChild={true} disabled={t4}>{t5}</Button></div></CardContent></Card>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
export { DoneStep };